import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';
import { RelationshipCategory } from '../_models/relationship-category.model';
import {
  RelationshipCategoryActions,
  RelationshipCategoryActionTypes,
} from '../_actions/relationship-category.actions';

export interface RelationshipCategoryState extends EntityState<RelationshipCategory> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedRelationshipCategoryId: number;
  lastCreatedRelationshipCategory: RelationshipCategory;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<RelationshipCategory> =
  createEntityAdapter<RelationshipCategory>();

export const initialRelationshipCategoryState: RelationshipCategoryState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedRelationshipCategoryId: undefined,
  lastCreatedRelationshipCategory: undefined,
  showInitWaitingMessage: true,
});

export function RelationshipCategoryReducer(
  state = initialRelationshipCategoryState,
  action: RelationshipCategoryActions,
): RelationshipCategoryState {
  switch (action.type) {
    case RelationshipCategoryActionTypes.RelationshipCategoryPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedRelationshipCategoryId: undefined,
      };
    case RelationshipCategoryActionTypes.RelationshipCategoryActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case RelationshipCategoryActionTypes.RelationshipCategoryDeleted:
      return adapter.removeOne(action.payload.id, state);
    case RelationshipCategoryActionTypes.RelationshipCategoryPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case RelationshipCategoryActionTypes.RelationshipCategoryPageLoaded: {
      return adapter.addMany(action.payload.relationshipCategory, {
        ...initialRelationshipCategoryState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case RelationshipCategoryActionTypes.ThrowRelationshipCategoryError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case RelationshipCategoryActionTypes.FireRelationshipCategorySuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getRelationshipCategoryState =
  createFeatureSelector<RelationshipCategoryState>('RelationshipCategory');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
